<div class="genres" data-testid="HomePage.heroItemDetailsGenres">
  <ng-container *ngFor="let genre of genres; let first = first">
    <div class="genre-item">
      <svg-icon *ngIf="!first" key="osn-plus" class="plus-icon mx-2"></svg-icon>
      <a [routerLink]="getRouteUrl(genre.en)" [class.dark-text]="darkTextColor" (click)="onGenreClick(genre)">{{
        genre | currentLocale
      }}</a>
    </div>
  </ng-container>
</div>
